import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { MachineActions } from "redux/actions/settings/MachineActions";
import { ModalActions } from "redux/actions/ModalActions";
import { MachineTypeActions } from "redux/actions/settings/MachineTypeActions";
import { UserActions } from "redux/actions/settings/UserActions";

import { TableColumn, Table, TableRow } from "app/components/common/Table";
import { StoreModel } from "models/StoreModel";
import { LoginUser } from "models/LoginUser";
import { Machine } from "models/Machine";
import { MachineType } from "models/MachineType";
import { User } from "models/User";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import { Translations } from "models/Translations";
import Translator from "app/components/common/Translator";

interface Props {
    fetchMachines: typeof MachineActions.fetchMachines;
    fetchMachineTypes: typeof MachineTypeActions.fetchMachineTypes;
    fetchAllUserData: typeof UserActions.fetchAllUserData;
    addMachineForm: typeof ModalActions.showModal;
    addMachine: typeof MachineActions.addMachine;
    editMachineForm: typeof ModalActions.showModal;
    editMachine: typeof MachineActions.editMachine;
    deleteMachine: typeof MachineActions.deleteMachine
    loginUser: LoginUser;
    machines: Machine[];
    machineTypes: MachineType[];
    users: User[];
    translations: Translations;
}

class Machines extends React.Component<Props> {
    componentDidMount() {
        if (this.loggedIn()) {
            if (!this.props.machines) {
                this.props.fetchMachines(this.props.loginUser.token);
            }
            if (!this.props.machineTypes) {
                this.props.fetchMachineTypes(this.props.loginUser.token);
            }
            if (!this.props.users) {
                this.props.fetchAllUserData(this.props.loginUser.token);
            }
        }
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    ready() {
        return this.loggedIn() && this.props.machines && this.props.machineTypes && this.props.users
    }

    setMachineData(): TableRow[] {
        let data: TableRow[] = [];
        {
            this.props.machines.forEach(machine => {
                data.push({
                    dataObject: {
                        id: machine.id,
                        name: machine.name,
                        machineType: machine.machineType,
                        identification: machine.identification,
                        serviceLife: machine.serviceLife,
                        archivedDate: machine.archivedDate,
                        user: machine.user
                    },
                    cells: [
                        { name: "user", sortVal: machine.user?.userName ?? '', cell: <>{machine.user?.userName}</> },
                    ]
                })
            })
        }
        return data;
    }

    setColumns(): TableColumn[] {
        // TODO maybe dynamic??
        return [
            {
                header: 'Id',
                accessor: 'id',
            },
            {
                header: 'Machine Name',
                accessor: 'name',
            },
            {
                header: 'Machine Type',
                accessor: 'machineType',
            },
            {
                header: 'Identification',
                accessor: 'identification',
            },
            {
                header: 'Service Life',
                accessor: 'serviceLife',
            },
            {
                header: 'Assigned User',
                accessor: 'user',
            },
        ];
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="Machines" />
                    <Translator text="Loading" />
                </div>
            )
        }
        return (
            <div className="c-page__content">
                <PageContentHeader text="Machines" />
                <div className="c-card">
                    <Table
                        addAction={this.props.addMachine}
                        addFormAction={this.props.addMachineForm}
                        addFormData={{
                            header: "Add a new Machine",
                            formObject: { ...Machine.empty(), user: null },
                        }}
                        editAction={this.props.editMachine}
                        editFormAction={this.props.editMachineForm}
                        editFormData={{
                            header: "Edit Machine",
                        }}
                        deleteAction={this.props.deleteMachine}
                        selectConfigs={[{ divId: 'user', storeKey: 'users', label: (u: object) => (u as User).userName }]}
                        optionals={['user']}
                        editable={true}
                        columns={this.setColumns()}
                        tableData={this.setMachineData()}
                        translations={this.props.translations}
                        loginUser={this.props.loginUser}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        machines: state.machines,
        machineTypes: state.machineTypes,
        users: state.users,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        fetchMachines: bindActionCreators(MachineActions.fetchMachines, dispatch),
        fetchMachineTypes: bindActionCreators(MachineTypeActions.fetchMachineTypes, dispatch),
        fetchAllUserData: bindActionCreators(UserActions.fetchAllUserData, dispatch),
        addMachine: bindActionCreators(MachineActions.addMachine, dispatch),
        addMachineForm: bindActionCreators(ModalActions.showModal, dispatch),
        editMachine: bindActionCreators(MachineActions.editMachine, dispatch),
        editMachineForm: bindActionCreators(ModalActions.showModal, dispatch),
        deleteMachine: bindActionCreators(MachineActions.deleteMachine, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Machines);